<template>
  <div class="content">
    <div class="performance">
    <div v-if="loading" class="text-center py-4">
      <Card>
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-2">Checking Trello authentication...</p>
        <p v-if="loadingTimeout" class="text-warning mt-2">
          Taking longer than expected...
          <button @click="retryCheck" class="btn btn-sm btn-warning">Retry</button>
        </p>
      </Card>
    </div>
    <div v-else-if="!isTrelloConnected" class="text-center py-5">
      <Card>
        <img
          src="https://d2k1ftgv7pobq7.cloudfront.net/meta/c/p/res/images/trello-header-logos/76ceb1faa939ede03abacb6efacdde16/trello-logo-blue.svg"
          alt="Trello Logo" class="mb-4 mt-2" style="width: 150px; height: auto;" />
        <h4 class="mb-3">Connect to Trello</h4>
        <p class="mb-4">Please connect your Trello account to view performance metrics.</p>
        <button @click="loginWithTrello" class="connet-to-trello-btn" style="margin-bottom: 20px;">
          Login with Trello
        </button>
      </Card>

    </div>

    <div v-else>
      <Performance :selectedEmployeeTrelloUsername="selectedEmployeeTrelloUsername" @logoutFromTrello="handleLogout"/>
    </div>
  </div>
  </div>
</template>

<script>
import Performance from "./Performance.vue";
import Card from "../UIComponents/Cards/Card.vue";
import firebase from '@/assets/config/firebase';
import 'firebase/firestore';

export default {
  components: {
    Performance,
    Card
  },
  data() {
    const user = this.$store.state.auth.user;
    return {
      selectedEmployeeTrelloUsername:"",
      isAdmin: user && user.role === "admin",
      loading: true,
      loadingTimeout: false,
      isTrelloConnected: false,
      trelloApiKey: process.env.PROD_VUE_APP_TRELLO_API_KEY,
    };
  },
  methods: {
    retryCheck() {
      this.loading = true;
      this.loadingTimeout = false;
      this.checkForTrelloToken();
    },
  },
  mounted() {
    const hash = window.location.hash;
    const tokenMatch = hash.match(/(?:[?&]token=)([^&]+)/);

    if (tokenMatch && tokenMatch[1]) {
      const token = tokenMatch[1];
      localStorage.setItem('trello_token', token);

      window.history.replaceState({}, '', '/#/performance');
    }

    this.checkForTrelloToken();
    setTimeout(() => {
      if (this.loading) this.loadingTimeout = true;
    }, 5000);
  },
  methods: {
    async checkForTrelloToken() {
      this.loading = true;
      const token = localStorage.getItem('trello_token');

      if (!token) {
        this.isTrelloConnected = false;
        this.loading = false;
        return;
      }
      this.isTrelloConnected = true;
      this.loading = false;
      try {
        const response = await fetch(
          `https://api.trello.com/1/tokens/${token}?key=${this.trelloApiKey}&fields=idMember`
        );
        const respondata = await response.json()
        if (!response.ok) throw new Error('Invalid token');
        await this.validateTrelloToken(token);
        this.isTrelloConnected = true;
      } catch (error) {
        localStorage.removeItem('trello_token');
        this.isTrelloConnected = false;
      }
    },

    async validateTrelloToken(token) {
      try {
        const response = await fetch(
          `https://api.trello.com/1/members/me?key=${this.trelloApiKey}&token=${token}`
        );

        if (response.ok) {
          const userData = await response.json();
          await this.storeTrelloUserInFirebase(userData, token);
          this.isTrelloConnected = true;
        } else {
          localStorage.removeItem("trello_token");
          this.isTrelloConnected = false;
          throw new Error("Invalid Trello token");
        }
      } catch (error) {
        console.error("Error validating Trello token:", error);
        localStorage.removeItem("trello_token");
        this.isTrelloConnected = false;
        throw error;
      }
    },
    async storeTrelloUserInFirebase(userData) {
      try {
        const username = userData.username || "";
        const userId = this.$store.state.auth.user.uid;
        await firebase.saveTrelloUser(userId, username);
        this.selectedEmployeeTrelloUsername = username;
      } catch (error) {
        console.error("Error saving Trello username:", error);
      }
    },

    loginWithTrello() {
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/#/performance?auth=trello`;

      const authUrl = `https://trello.com/1/authorize?expiration=never&scope=read&response_type=token&key=${this.trelloApiKey}&return_url=${encodeURIComponent(redirectUrl)}`;

      window.location.href = authUrl;
    },

    handleLogout() {
      localStorage.removeItem('trello_token');
      this.isTrelloConnected = false;
      this.selectedEmployeeTrelloUsername = "";
    },
  },
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/Performance/index.vue